/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Achievementsbasegamelabel3Inputs */

const id_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Dasar`)
};

const ms_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Asas`)
};

const da_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basespil`)
};

const de_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basisspiel`)
};

const en_us2_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Game`)
};

const es_es2_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego base`)
};

const es_mx2_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego base`)
};

const fil_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Game`)
};

const fr_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu de base`)
};

const it_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco base`)
};

const hu_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alapjáték`)
};

const nl_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basespel`)
};

const no_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grunnspill`)
};

const pl_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra podstawowa`)
};

const pt_br2_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo básico`)
};

const pt_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo base`)
};

const ro_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joc de bază`)
};

const fi_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruspeli`)
};

const sv_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundspel`)
};

const vi_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game cơ bản`)
};

const tr_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temel Oyun`)
};

const cs_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základní hra`)
};

const bg_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основна игра`)
};

const ru_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовая игра`)
};

const uk_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базова гра`)
};

const ar_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللعبة الأساسية`)
};

const hi_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेस गेम`)
};

const th_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมหลัก`)
};

const ja_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベースゲーム`)
};

const zh_cn2_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础游戏`)
};

const zh_hant1_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎遊戲`)
};

const ko_sandboxes_achievementsbasegamelabel3 = /** @type {(inputs: Sandboxes_Achievementsbasegamelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 게임`)
};

/**
* | output |
* | --- |
* | "Base Game" |
*
* @param {Sandboxes_Achievementsbasegamelabel3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_achievementsbasegamelabel3 = /** @type {((inputs?: Sandboxes_Achievementsbasegamelabel3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Achievementsbasegamelabel3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "ms") return ms_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "da") return da_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "de") return de_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "en-US") return en_us2_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "fil") return fil_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "fr") return fr_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "it") return it_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "hu") return hu_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "nl") return nl_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "no") return no_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "pl") return pl_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "pt") return pt_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "ro") return ro_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "fi") return fi_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "sv") return sv_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "vi") return vi_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "tr") return tr_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "cs") return cs_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "bg") return bg_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "ru") return ru_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "uk") return uk_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "ar") return ar_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "hi") return hi_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "th") return th_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "ja") return ja_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_achievementsbasegamelabel3(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_achievementsbasegamelabel3(inputs)
	return ko_sandboxes_achievementsbasegamelabel3(inputs)
});
export { sandboxes_achievementsbasegamelabel3 as "sandboxes.achievementsBaseGameLabel" }